import OrderedList, { OrderedListProps } from "components/blocks/orderedList"
import RichText, { RichTextProps } from "components/elements/richText"
import ActionsList, { ActionsListProps } from "components/sections/actionsList"
import BlogFeature from "components/sections/BlogFeature"
import ContactJumpstartCtaV2, {
  ContactJumpstartCtaV2Props,
} from "components/sections/contactJumpstartCtaV2"
import DynamicSection, {
  DynamicSectionProps,
} from "components/sections/dynamicSection"
import Faq from "components/sections/faq"
import HeroImage, { HeroImageProps } from "components/sections/heroImage"
import HeroVideo, { HeroVideoProps } from "components/sections/heroVideo"
import HomeHeroV2, { HomeHeroV2Props } from "components/sections/homeHeroV2"
import LocationSectionV2, {
  LocationSectionV2Props,
} from "components/sections/locationSectionV2"
import LogoBarV2, { LogoBarV2Props } from "components/sections/logoBarV2"
import PageHeader, { PageHeaderProps } from "components/sections/pageHeader"
import PageHeroV2, { PageHeroV2Props } from "components/sections/pageheroV2"
import QuoteSection, {
  QuoteSectionProps,
} from "components/sections/quoteSection"
import SectionCards, {
  SectionCardsProps,
} from "components/sections/sectionCards"
import SectionList, { SectionListProps } from "components/sections/sectionList"
import SectionVersusV2, {
  SectionVersusV2Props,
} from "components/sections/sectionVersusV2"
import SideBySide, { SideBySideProps } from "components/sections/sideBySide"
import SplitSection from "components/sections/splitSection"
import SplitSectionV2, {
  SplitSectionV2Props,
} from "components/sections/splitSectionV2"
import SplitStickySectionV2 from "components/sections/splitStickySectionV2"
import TestimonialsV2, {
  TestimonialsV2Props,
} from "components/sections/testimonialsV2"

import SectionAccordionV2, {
  SectionAccordionV2Props,
} from "components/sections/sectionAccordionV2"
import SectionCardGridV2 from "components/sections/sectionCardGridV2"
import SectionPathV2, {
  SectionPathV2Props,
} from "components/sections/sectionPathV2"
import SectionRoadmapV2, {
  SectionRoadmapV2Props,
} from "components/sections/sectionRoadmapV2"
import SectionSplitAccordionV2 from "components/sections/sectionSplitAccordionV2"
import SectionSplitImageCarouselV2, {
  SectionSplitImageCarouselV2Props,
} from "components/sections/sectionSplitImageCarouselV2"
import SectionSplitStepsUpV2, {
  SectionSplitStepsUpV2Props,
} from "components/sections/sectionSplitStepsUpV2"
import TextSection, { TextSectionProps } from "components/sections/textSection"
import Wrapper, { WrapperProps } from "components/sections/wrapper"
import PropTypes from "prop-types"
import React from "react"
import COMPONENTS from "utils/componentConstants"
import SECTIONS from "utils/sectionConstants"
import ReferralPageDetails from "views/referralDetails"
const WebpageTemplate = ({ sections, slug }) =>
  sections.map((section, i) => {
    switch (section.__typename) {
      case SECTIONS.Subheader:
        return <PageHeader {...section} key={i} />

      case SECTIONS.SectionListOfActions:
        return <ActionsList {...section} key={i} />

      case SECTIONS.ContentfulSectionRichText:
        return <RichText {...section} className={`page-${slug}`} key={i} />

      case SECTIONS.HeroVideo:
        return <HeroVideo data={section} key={i} />

      case SECTIONS.TextSection:
        return <TextSection {...section} key={i} />

      case SECTIONS.DynamicSection: {
        const featuredArticlesSection = sections?.find(
          sec => sec.__typename === SECTIONS.FeaturedArticles
        )
        const featuredArticles = featuredArticlesSection
          ? featuredArticlesSection.featuredArticles
          : []

        return (
          <DynamicSection
            data={section}
            featuredArticles={featuredArticles}
            key={i}
          />
        )
      }
      case SECTIONS.SectionList:
        return <SectionList {...section} key={i} />

      case SECTIONS.HighlightedBlog:
        return <BlogFeature {...section} key={i} />

      case SECTIONS.SideBySide:
        return <SideBySide {...section} key={i} />

      case SECTIONS.SectionCards:
        return <SectionCards {...section} key={i} />

      case SECTIONS.SectionHeroPhoto:
        return <HeroImage {...section} key={i} />

      case SECTIONS.SectionQuote:
        return <QuoteSection {...section} key={i} />

      case SECTIONS.WrapperSection:
        return <Wrapper {...section} key={i} />

      case SECTIONS.OrderedList:
        return <OrderedList {...section} key={i} />

      case SECTIONS.TemplateDetailsSection:
        return <ReferralPageDetails {...section} key={i} />

      case COMPONENTS.SplitContent:
        return <SplitSection {...section} key={i} />

      case COMPONENTS.Faq:
        return <Faq {...section} key={i} />

      case SECTIONS.SectionHomeHeroV2:
        return <HomeHeroV2 {...section} key={i} />

      case SECTIONS.SectionLogoBarV2:
        return <LogoBarV2 {...section} key={i} />

      case SECTIONS.SectionHomeSplitStickyV2:
        return <SplitStickySectionV2 {...section} key={i} />

      case SECTIONS.SectionSearchAndFeaturedClinicsV2:
        return <LocationSectionV2 {...section} key={i} />

      case SECTIONS.SectionSplitSectionV2:
        return <SplitSectionV2 {...section} key={i} />

      case SECTIONS.SectionContactJumpstartCtaV2:
        return <ContactJumpstartCtaV2 {...section} key={i} />

      case SECTIONS.SectionTestimonials:
        return <TestimonialsV2 {...section} key={i} />

      case SECTIONS.SectionPageHeroV2:
        return <PageHeroV2 {...section} key={i} />

      case SECTIONS.SectionVersusV2:
        return <SectionVersusV2 {...section} key={i} />

      case SECTIONS.SectionSplitStepsUpV2:
        return <SectionSplitStepsUpV2 {...section} key={i} />

      case SECTIONS.SectionSplitAccordionV2:
        return <SectionSplitAccordionV2 {...section} key={i} />

      case SECTIONS.SectionRoadmapV2:
        return <SectionRoadmapV2 {...section} key={i} />

      case SECTIONS.SectionSplitImageCarouselV2:
        return <SectionSplitImageCarouselV2 {...section} key={i} />

      case SECTIONS.SectionPathV2:
        return <SectionPathV2 {...section} key={i} />

      case SECTIONS.SectionAccordionV2:
        return <SectionAccordionV2 {...section} key={i} />

      case SECTIONS.SectionCardGridV2:
        return <SectionCardGridV2 {...section} key={i} />

      default:
        return null
    }
  })

WebpageTemplate.props = {
  sections: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(ActionsListProps),
      PropTypes.shape(DynamicSectionProps),
      PropTypes.shape(HeroImageProps),
      PropTypes.shape(HeroVideoProps),
      PropTypes.shape(OrderedListProps),
      PropTypes.shape(PageHeaderProps),
      PropTypes.shape(QuoteSectionProps),
      PropTypes.shape(RichTextProps),
      PropTypes.shape(SectionCardsProps),
      PropTypes.shape(SectionListProps),
      PropTypes.shape(SideBySideProps),
      PropTypes.shape(TextSectionProps),
      PropTypes.shape(WrapperProps),
      PropTypes.shape(HomeHeroV2Props),
      PropTypes.shape(LogoBarV2Props),
      PropTypes.shape(LocationSectionV2Props),
      PropTypes.shape(SplitSectionV2Props),
      PropTypes.shape(ContactJumpstartCtaV2Props),
      PropTypes.shape(TestimonialsV2Props),
      PropTypes.shape(PageHeroV2Props),
      PropTypes.shape(SectionVersusV2Props),
      PropTypes.shape(SectionSplitStepsUpV2Props),
      PropTypes.shape(SectionRoadmapV2Props),
      PropTypes.shape(SectionSplitImageCarouselV2Props),
      PropTypes.shape(SectionPathV2Props),
      PropTypes.shape(SectionAccordionV2Props),
    ])
  ),
  slug: PropTypes.string,
  title: PropTypes.string,
}

WebpageTemplate.propTypes = WebpageTemplate.props

export default WebpageTemplate
